import { useGlobalStore } from '@/stores';
import { ACCOUNT_TYPE } from '@/constants/account-type';

/**
 * True for any INTERNAL user (staff). External customers are false.
 * Backed by the `accountType` field on `/v1/auth/me` — no more role-string
 * sniffing.
 */
export const useIsEmployee = (): boolean => {
  const accountType = useGlobalStore((state) => state.accountType);
  return accountType === ACCOUNT_TYPE.INTERNAL;
};
